import React, { useState } from "react";
import { Stack } from "@mui/material";

import { HubButton, HubButtonGroup, PageContent } from "../../components";
import { SalesQuotesKanban } from "../../containers/SalesKanban";
import { SalesQuotesTable } from "../../tables/SalesQuotesTable";
import { QuoteDialog } from "../../dialogs/QuoteDialog";
import { StyledHubButtonGroup } from "./styles";
import QuotesBar from "./QuotesBar";

const VIEW_MODES = [
  { id: 0, label: "Board", icon: "CreditCard" },
  { id: 1, label: "Table", icon: "List" },
];

const STORAGE_VIEW = "Quotes-View";

export const QuotesPage = () => {
  const [viewMode, setViewMode] = useState(() => {
    const cached = localStorage?.getItem(STORAGE_VIEW);
    return cached != null ? Number(cached) : 0;
  });

  const onSetViewMode = (val) => {
    localStorage?.setItem(STORAGE_VIEW, val);
    setViewMode(val);
  };

  const ActiveView = viewMode === 1 ? SalesQuotesTable : SalesQuotesKanban;

  return (
    <PageContent disablePadding white>
      <Stack sx={{ width: "100%", height: "100%" }}>
        <QuotesBar viewMode={viewMode} setViewMode={onSetViewMode} />
        <Stack flex={1} sx={{ overflow: "auto" }}>
          <ActiveView />
        </Stack>
      </Stack>
      <QuoteDialog />
    </PageContent>
  );
};

export default QuotesPage;
